jQuery(document).ready(function ($) {
  // Page Load
  // $(".full-loader").removeClass("hide");

  let pageNum = 1;
  var featuredBlogIds = $(".featured-blog .post")
    .map(function () {
      return Number(String($(this).data("id")).trim());
    })
    .get();

  var editorsPickIds = $(".editors-pick .post")
    .map(function () {
      return Number(String($(this).data("id")).trim());
    })
    .get();

  var mostPopularIds = $(".most-popular-articles .post")
    .map(function () {
      return Number(String($(this).data("id")).trim());
    })
    .get();

  //   Listeners for UI
  $("#sort-order").on("click", function () {
    if ($(".wf-blog-posts").attr("data-filtered") === "1") {
      var currentSort = $(this).attr("data-sort");
      var newSort = currentSort === "ASC" ? "DESC" : "ASC";
      $(this).attr("data-sort", newSort);
      applyFilters();
    }
  });

  $(".filters-option-dropdown").on("click", function () {
    $(".filter-dropdown-wrapper").toggleClass("show-on-mobile");
  });

  // Toggle dropdown options on click of label
  $(".custom-dropdown").on("click", function () {
    $(this).find(".dropdown-options").toggle();
    // Close all other dropdowns
    $(".custom-dropdown").not(this).find(".dropdown-options").hide();
  });

  // When an option from categories dropdown is clicked
  $("#categories-dropdown .option").on("click", function () {
    const value = $(this).attr("data-value");
    const label = $(this).text();
    if (!$(this).hasClass("active")) {
      addActiveFilter(value, label, "category");
    } else {
      removeActiveFilter(value, label, "category");
      // Toggling dropdown
      $(this).next(".dropdown-options").toggle();
    }
    applyFilters();
    updateFilteredStatus();
  });

  // When an option from archive dropdown is clicked
  $("#archive-dropdown .option").on("click", function () {
    const value = $(this).attr("data-value");
    const label = $(this).text();

    if (!$(this).hasClass("active")) {
      addActiveFilter(value, label, "archive");
    } else {
      removeActiveFilter(value, label, "archive");
    }

    applyFilters();
    updateFilteredStatus();
  });

  // Remove active filter
  $("#active-filters").on("click", ".remove-filter", function (e) {
    e.preventDefault();
    let value = $(this).parent(".filter-tag").attr("data-value");
    let type = $(this).parent(".filter-tag").attr("data-type");

    removeActiveFilter(value, null, type);
    applyFilters();
    updateFilteredStatus();
  });

  //   Clear all filters
  $("#active-filters").on("click", "#clear-filters", function (e) {
    e.preventDefault();
    const url = new URL(window.location.href);
    url.search = "";
    window.history.pushState({}, "", url);
    location.reload();
  });

  $(".year-option").on("click", function (e) {
    e.stopPropagation();
    const $months = $(this).find(".months");
    if ($months.is(":visible")) {
      $months.hide();
      $(this).attr("aria-expanded", "false");
    } else {
      $months.show();
      $(this).attr("aria-expanded", "true");
    }
  });

  // When a month is selected from archive dropdown
  $(".month-option").on("click", function (e) {
    e.stopPropagation();
    const value = $(this).attr("data-value");
    const label = $(this).text();
    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
      addActiveFilter(value, label, "archive");
    } else {
      removeActiveFilter(value, label, "archive");
    }

    applyFilters();
    updateFilteredStatus();
    $(".custom-dropdown").find(".dropdown-options").hide();
  });

  // $(".posts-pagination").on("click", "button", function () {
  //   const clickedPage = $(this).data("page");
  //   console.log("clickedPage", clickedPage);
  //   pageNum = clickedPage;
  //   applyFilters();
  // });

  function removeActiveFilter(value, label, type) {
    // $(
    //   `#active-filters .filter-tag[data-value='${value}'][data-type='${type}']`
    // ).remove();
    if (type !== "archive") {
      $(`.option[data-value='${value}']`).removeClass("active");
    } else {
      $(`.month-option[data-value='${value}']`).removeClass("active");
    }
    if (type === "search") {
      // $("#active-filters .filter-tag[data-type='search']").remove();
      $("#search-input").val("");
    }
  }

  function addActiveFilter(value, label, type) {
    if (
      !$(
        `#active-filters .filter-tag[data-value='${value}'][data-type='${type}']`
      ).length
    ) {
      if (type === "archive") {
        label = label.replace(/\(\d+\)/g, "").trim();
      }
      if (type === "search") {
        $("#search-input").val(value);
      }
      // const filterTag = `<span class='filter-tag' data-value='${value}' data-type='${type}'>${label} <a href='#' class='remove-filter'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M10.9097 2.02256C11.2759 1.65644 11.2759 1.06285 10.9097 0.696733C10.5436 0.330617 9.95004 0.330617 9.58392 0.696733L5.60644 4.67421L1.62897 0.696733C1.26285 0.330617 0.669261 0.330617 0.303145 0.696733C-0.0629726 1.06285 -0.062972 1.65644 0.303145 2.02256L4.28062 6.00003L0.303145 9.97751C-0.0629723 10.3436 -0.0629716 10.9372 0.303145 11.3033C0.669261 11.6695 1.26285 11.6695 1.62897 11.3033L5.60645 7.32586L9.58392 11.3033C9.95004 11.6695 10.5436 11.6695 10.9097 11.3033C11.2759 10.9372 11.2759 10.3436 10.9097 9.97751L6.93227 6.00003L10.9097 2.02256Z" fill="#290350"/></svg></a></span>`;
      // $(filterTag).insertBefore("#clear-filters");
      if (type !== "archive") {
        $(`.option[data-value='${value}']`).addClass("active");
      } else {
        $(`.month-option[data-value='${value}']`).addClass("active");
      }
    }
  }

  function updateFilteredStatus() {
    var hasActiveFilters = $("#active-filters .filter-tag").length > 0;
    // var hasSearchQuery = $("#search-input").val().trim().length > 0;

    if (hasActiveFilters) {
      $("#sort-order").attr("aria-disabled", false);
      $(".posts-title").addClass("hide");
      $(".wf-blog-posts").attr("data-filtered", "1");
    } else {
      $("#sort-order").attr("aria-disabled", true);
      $(".posts-title").removeClass("hide");
      $(".wf-blog-posts").attr("data-filtered", "0");
    }
    if (hasActiveFilters) {
      $("#active-filters").removeClass("hide");
    } else {
      $("#active-filters").addClass("hide");
    }
  }

  $("#search").on("click", function () {
    var searchTerm = $("#search-input").val().trim();
    removeActiveFilter(searchTerm, null, "search");
    addActiveFilter(searchTerm, `Search: ${searchTerm}`, "search");
    applyFilters();
    updateFilteredStatus();
  });

  $("#search-input").on("keyup", function (e) {
    if (e.key === "Enter") {
      $("#search").click();
    }
  });

  function applyFilters() {
    let url = new URL(window.location.href);
    let params = url.searchParams;

    // Categories
    let selectedCategories = [];
    $("#categories-dropdown .option.active").each(function () {
      selectedCategories.push($(this).attr("data-value"));
    });
    if (selectedCategories.length > 0) {
      params.set("categories", selectedCategories.join(","));
    } else {
      params.delete("categories");
    }

    // Months
    let existingMonths = params.get("month")
      ? params.get("month").split(",")
      : [];
    $("#archive-dropdown .month-option").each(function () {
      let selectedMonth = $(this).attr("data-value");
      let monthIndex = existingMonths.indexOf(selectedMonth);
      if ($(this).hasClass("active")) {
        if (monthIndex === -1) {
          existingMonths.push(selectedMonth);
        }
      } else {
        if (monthIndex > -1) {
          existingMonths.splice(monthIndex, 1);
        }
      }
    });
    if (existingMonths.length > 0) {
      params.set("month", existingMonths.join(","));
    } else {
      params.delete("month");
    }

    // Order
    let selectedOrder = $("#sort-order").attr("data-sort");
    if (selectedOrder) {
      params.set("order", selectedOrder);
    } else {
      params.delete("order");
    }

    // Search
    let searchQuery = $("#search-input").val().trim();
    if (searchQuery) {
      params.set("search", searchQuery);
    } else {
      params.delete("search");
    }

    // Page
    params.delete("paged");
    // remove /page/# from url

    url.pathname = url.pathname.replace(/\/page\/\d+/, "");
    console.log("url.pathname", url.pathname);
    console.log("url.search", url.toString());
    // Update the URL
    window.location.href = url.toString();
  }
});
